<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">{{ $t('editingBlobStorageConfig') }}</span>
      <v-spacer/>
      <Icon
        iconColor="white"
        icon="mdi-close"
        :small="false"
        large
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        strongValidation
        @submit="done()"
        :buttonText="$t('done')">
        <v-container fluid>
          <v-row class="mt-2" v-for="(conn, index) in config" :key="index">
            <v-col cols="12">
              <v-text-field
                :label="conn.name"
                :type="hidden[index] ? 'password' : 'text'"
                v-model="conn.connectionString"
                :rules="[v => validateConnectionString(v)]"
                autocomplete="off">
                <template #append-outer>
                  <Icon
                    :small="false"
                    :icon="hidden[index] ? 'mdi-eye-off' : 'mdi-eye'"
                    icon-color="black"
                    @icon-clicked="$set(hidden, index, !hidden[index])"
                    :tooltipText="hidden[index] ? $t('showConnectionString') : $t('hideConnectionString')"/>
                </template>
              </v-text-field>
              <div v-if="getExpiry(conn)" class="d-flex align-center mb-3">
                <v-icon small :color="getExpiryColor(conn)">mdi-clock-outline</v-icon>
                <span :class="['ml-1', getExpiry(conn) > new Date() ? 'grey--text text--darken-2' : 'error--text']">
                  {{ getExpiry(conn) > new Date() ? $t('connectionStringExpiresAt', { date: formatExpiry(getExpiry(conn)) }) : $t('connectionStringExpiredAt', { date: formatExpiry(getExpiry(conn)) }) }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'

export default {
  name: 'BlobStorageConfigForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    propConfig: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    hidden: [],
    config: []
  }),

  created () {
    this.config = cloneDeep(this.propConfig)
    this.hidden = this.config.map(() => true)
  },

  methods: {
    moment,

    parseSasExpiry (connectionString) {
      if (!connectionString) return null
      const match = connectionString.match(/se=([^&;]+)/i)
      if (!match) return null
      try {
        const date = new Date(decodeURIComponent(match[1]))
        return isNaN(date.getTime()) ? null : date
      } catch {
        return null
      }
    },

    getExpiry (conn) {
      return this.parseSasExpiry(conn.connectionString)
    },

    getExpiryColor (conn) {
      const expiry = this.getExpiry(conn)
      if (!expiry) return 'grey'
      return expiry > new Date() ? 'grey darken-2' : 'error'
    },

    formatExpiry (date) {
      return moment(date).format('LLL')
    },

    validateConnectionString (val) {
      if (!val || !val.trim()) return this.$t('required')
      const expiry = this.parseSasExpiry(val)
      if (expiry && expiry <= new Date()) return this.$t('connectionStringExpired')
      return true
    },

    done () {
      this.$emit('done-editing', cloneDeep(this.config))
    }
  }
}
</script>
